const data = {
  home: {
    title: "Curt Henrichs | Portfolio | Home",
    description:
      "Hello, I'm Curt, an embedded systems engineer currently working on peripherals for electron microscopes. I am passionate about building real things for real people.",
    path: "/",
    ogType: "profile"
  },
  career: {
    title: "Curt Henrichs | Portfolio | Career",
    description:
      "Career history of Curt Henrichs: embedded systems engineering at IDES, human-robot interaction research at UW-Madison, and an R&D internship at Dedicated Computing.",
    path: "/career"
  },
  education: {
    title: "Curt Henrichs | Portfolio | Education",
    description:
      "Curt Henrichs' education: M.S. in Computer Science from the University of Wisconsin - Madison and B.S. in Computer Engineering from the Milwaukee School of Engineering.",
    path: "/education"
  },
  projects: {
    title: "Curt Henrichs | Portfolio | Projects",
    description:
      "Projects by Curt Henrichs, including the Authr, CoFrame, and ITER human-robot interaction research systems plus hobby robotics and home automation builds.",
    path: "/projects"
  },
  publications: {
    title: "Curt Henrichs | Portfolio | Publications",
    description:
      "Peer-reviewed publications by Curt Henrichs on human-robot teaming, cobot programming interfaces, and electron microscopy instrumentation.",
    path: "/publications"
  },
  contract: {
    title: "Curt Henrichs | Portfolio | Contracting",
    description:
      "Contracting and consulting with Curt Henrichs for embedded systems, firmware, and software development work.",
    path: "/contract"
  },
  attribution: {
    title: "Curt Henrichs | Portfolio | Attribution",
    description:
      "Image, icon, and logo attribution for content used on curthenrichs.github.io.",
    path: "/attribution"
  },
  terms: {
    title: "Curt Henrichs | Portfolio | Terms of Use",
    description: "Plain-language terms of use for curthenrichs.github.io.",
    path: "/terms"
  },
  accessibility: {
    title: "Curt Henrichs | Portfolio | Accessibility",
    description:
      "Accessibility statement and practices for curthenrichs.github.io.",
    path: "/accessibility"
  },
  privacy: {
    title: "Curt Henrichs | Portfolio | Privacy Policy",
    description:
      "Plain-language privacy policy for curthenrichs.github.io.",
    path: "/privacy"
  },
  notFound: {
    title: "Curt Henrichs | Portfolio | Page Not Found",
    description: "The requested page was not found on curthenrichs.github.io.",
    path: "/404",
    robots: "noindex"
  },
  docsNotFound: {
    title: "Curt Henrichs | Portfolio | Document Not Found",
    description:
      "The requested document was not found on curthenrichs.github.io.",
    path: "/docs",
    robots: "noindex"
  }
};

export default data;
